import { useEffect, useRef, useState } from "react";

export default function Footer() {
  const footerRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = footerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "What We Remove", href: "#services" },
    { label: "How It Works", href: "#process" },
    { label: "Why Us", href: "#why-us" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <footer ref={footerRef} className="bg-dark-950 border-t border-dark-800">
      <div className="px-4 md:px-8 lg:px-12 py-12 md:py-16 max-w-6xl mx-auto">
        <div
          className={`flex flex-col md:flex-row justify-between items-start md:items-center gap-8 mb-10 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="flex items-center gap-2 mb-3"
            >
              <div className="w-8 h-8 rounded-lg bg-primary-600 flex items-center justify-center">
                <i className="ri-bar-chart-grouped-line text-white text-lg" />
              </div>
              <span className="font-heading font-bold text-lg text-white">
                Authentic
                <span className="text-primary-400">Credit</span>
              </span>
            </a>
            <p className="text-dark-400 text-sm max-w-sm leading-relaxed">
              One-on-one personal and corporate credit repair in all 50 states. Everything done utilizing the Fair Credit Reporting Act of 1984.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(link.href);
                }}
                className="text-dark-300 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div
          className={`pt-8 border-t border-dark-800 flex flex-col sm:flex-row justify-between items-center gap-4 transition-all duration-700 delay-200 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <p className="text-dark-500 text-xs">
            &copy; {new Date().getFullYear()} FastestCreditRestoration.com. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="mailto:info@fastestcreditrestoration.com"
              className="text-dark-400 hover:text-primary-400 text-xs transition-colors cursor-pointer"
            >
              info@fastestcreditrestoration.com
            </a>
            <span className="text-dark-700">|</span>
            <a
              href="tel:754-777-6321"
              className="text-dark-400 hover:text-primary-400 text-xs transition-colors cursor-pointer"
            >
              (754) 777-6321
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}